let isExpoGo;
try {
    const Constants = require('expo-constants').default;
    isExpoGo = Constants.appOwnership === 'expo';
}
catch (_a) {
    isExpoGo = false;
}
export default isExpoGo;
//# sourceMappingURL=isExpoGo.js.map